import type { FinalInspectionRequest } from '@/services/qc-workflow.service';

const QTY_TOL = 1e-4;

/** Planned quantity for this FIR (line item if set, else whole work order). */
export function getFirPlannedQuantity(fir: FinalInspectionRequest): number | undefined {
  const fromLi =
    fir.workOrderLineItem?.planned_quantity ??
    fir.lineItemResults?.[0]?.workOrderLineItem?.planned_quantity;
  if (fromLi != null && Number.isFinite(Number(fromLi))) return Number(fromLi);
  const woPlanned = fir.workOrder?.planned_quantity;
  if (woPlanned != null && Number.isFinite(Number(woPlanned))) return Number(woPlanned);
  return undefined;
}

/** True when approved + rejected > 0 and equals planned (full FIR approve rules). */
export function isFirApproveQuantityValid(fir: FinalInspectionRequest): boolean {
  const planned = getFirPlannedQuantity(fir);
  if (planned == null || planned <= 0) return false;
  const a = Number(fir.approved_quantity ?? 0);
  const b = Number(fir.rejected_quantity ?? 0);
  if (a <= 0 && b <= 0) return false;
  return Math.abs(a + b - planned) <= QTY_TOL;
}
